import { useLocation, useNavigate } from "react-router";
import { useBuyPanelsStore } from "./store";
import { useEffect } from "react";
import { useCurrentPath } from "@/hooks/useCurrentPath";
import { getBuyPanelsBasePath, getBuyPanelsRootSlug } from "./route";

export function useCompleteStep() {
  const navigate = useNavigate();
  const { setStepComplete, getNextStep } = useBuyPanelsStore();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const [base, slug] = pathSegments;

  const completeStep = (searchParams?: string) => {
    // Mark current step as complete
    // If slug exists, use it. Otherwise, use the first-step slug for the current route family
    if (slug) {
      setStepComplete(slug);
    } else if (base === getBuyPanelsRootSlug(location.pathname)) {
      setStepComplete("buypanels");
    } else {
      setStepComplete(base);
    }

    let fullPath = getNextStep();
    if (searchParams) {
      fullPath += `?${searchParams}`;
    }

    // Use setTimeout to ensure state update completes before navigation
    // This prevents the useValidateStep hook from seeing stale state
    setTimeout(() => {
      navigate(fullPath);
    }, 0);
  };

  return completeStep;
}

export function useValidateStep() {
  const navigate = useNavigate();
  const currentPath = useCurrentPath();
  const location = useLocation();
  const steps = useBuyPanelsStore((state) => state.steps);
  const hasHydrated = useBuyPanelsStore((state) => state._hasHydrated);

  useEffect(() => {
    // Don't validate until store has hydrated from localStorage
    if (!hasHydrated) return;

    if (currentPath === steps[steps.length - 1].slug) {
      // confirmation step
      return;
    }
    const currentStepIndex = steps.findIndex(
      (step) => step.slug === currentPath
    );

    if (currentStepIndex === -1) return;

    const basePath = getBuyPanelsBasePath(location.pathname);

    for (let i = 0; i < currentStepIndex; i++) {
      if (!steps[i].isCompleted) {
        navigate(
          i === 0 ? `${basePath}/` : `${basePath}/${steps[i].slug}`,
          { replace: true }
        );
        break;
      }
    }
  }, [currentPath, steps, navigate, location.pathname, hasHydrated]);
}
